import styled from 'styled-components';
import { colors } from 'shared/defaultTheme';

export const SpanCustom = styled.span`
  color: ${colors.suvaGrey};
  font-family: Roboto;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 16px;
`;

export const Upload = styled.div`
  cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')} !important;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'initial')} !important;
  border: ${({ isDrop }) =>
    isDrop ? `2px dashed ${colors.black} !important` : `1px solid ${colors.gullGrey}`};
  background: ${({ disabled }) => (disabled ? `${colors.colorReadonly}` : 'none')} !important;
  &:hover {
    border: ${({ disabled }) =>
      !disabled ? `2px dashed ${colors.black}` : `1px solid ${colors.lightSilver}`} !important;
  }
  .track-right-icon {
    height: 19px;
    width: 18px;
    margin-right: -7px;
  }
`;

export const UpdateDocumentFile = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  top: -1.8rem;
`;
